<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('customerNameText')" prop="loginName">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateRangePicker v-model="dataTime" :placeholder="$t('table.createTimeText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="status">
            <BjSelectLov v-model="queryParams.status" :placeholder="$t('table.statusText')" :option-list="DELIVERY_STATUS" clearable />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>    
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop == 'status'">{{ scope.row[col.prop] == 'Discard' ? $t('returnOrderStatusAbandonedText'):$t('normalText') }}</template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="viewOrderPallet(scope.row)">{{ $t('viewText')}}</el-button>
              <el-button type="text" class="edit-btn" :disabled="scope.row.status == 'Discard'" @click="_discardOrderPallet(scope.row)">{{ $t('returnOrderStatusAbandonedText') }}</el-button>
              <el-button type="text" @click="showLog(scope.row)">{{ $t('logText')}}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <innerDialog ref="innerDialogRef"/>
  </div>
</template>

<script>
import { purchaseApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import { DELIVERY_STATUS } from '@/utils/constants';
import innerDialog from './components/innerDialog';
import orderLog from '@/utils/log.js';
export default {
  mixins: [pageMiXin],
  components: {
    innerDialog
  },
  data() {
    return {
      queryApi: purchaseApi.getOrderPalletPageList,
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('BjDialogListConfig.Thirdordernumber'), prop: 'webReference', isCheck: true, disabled: false, width: '150' },
        // { label: this.$t('BjDialogListConfig.Internalordernumber'), prop: 'innerOrderNo', isCheck: true, disabled: false },
        { label: this.$t('billingPage.TotalPalletQty'), prop: 'totalPalletQty', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('billingPage.WoodenStandardQty'), prop: 'standardPallet', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('billingPage.ChepPalletQty'), prop: 'chepPallet', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('billingPage.LoscamPalletQty'), prop: 'loscomPallet', isCheck: true, disabled: false, width: '140' },
        // { label: this.$t('billingPage.ShrinkWrapQty'), prop: 'shripWrapQty', isCheck: true, disabled: false, width: '100' },
        // { label: this.$t('billingPage.liftOnQty'), prop: 'liftOnQty', isCheck: true, disabled: false, width: '80' },
        // { label: this.$t('billingPage.strapWrapQty'), prop: 'strapWrapQty', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('route.BusinessBillingServiceItem'), prop: 'serviceItem', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('billingPage.LabourTime'), prop: 'labourTime', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('billingPage.comments'), prop: 'comments', isCheck: true, disabled: false },
        { label: this.$t('table.statusText'), prop: 'status', isCheck: true, disabled: false, width: '80' },
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '180' },
      ],
      queryParams: {
        cusId: null,
        orderType: 'DT',
        creationDateBegin: '',
        creationDateEnd: ''
      },
      dataTime: [],
      DELIVERY_STATUS,
    };
  },
  watch: {
    dataTime(v){
            this.queryParams.creationDateBegin = (v || [])[0];
            this.queryParams.creationDateEnd = (v || [])[1];
        }
  },
  computed: {
    labelList() {
      return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
    },
  },
  methods: {
    showLog(row) {
          console.log(row,"row===>");
          
            orderLog(
                this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
                    actionApi:purchaseApi.getPurchaseLog,
                    defaultQuery: {
                      recordId:row.id,
                      recordType:"DELIVERY_NOTE"
                    },
                    columns: [
                        {
                            prop: 'operateName',
                            label: 'BjDialogListConfig.Operator',
                        },
                        {
                            prop: 'creationDate',
                            label: 'BjDialogListConfig.Operationtime',
                        },
                        {
                            prop: 'remark',
                            label: 'BjDialogListConfig.Remarks',
                        },
                    ],
                }),
            );
        },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.dataTime = [];
      this.queryParams.creationDateBegin = null;
      this.queryParams.creationDateEnd = null;
      this.queryParams.cusId = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    _discardOrderPallet(row) {
      purchaseApi.discardOrderPallet({id: row.id}).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    onAdd(){
            this.$toPage('BusinessBillingAddDeliveryNote');
        },
        viewOrderPallet(item){
          this.$refs.innerDialogRef.tableData = item.orderDetails;
          this.$refs.innerDialogRef.dialogVisible = true;
        }
  }
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>